import { LoginTranslation } from '../../types/login.types';

export const login: LoginTranslation = {
  title: 'Bienvenido al Mostrador',
  userLabel: 'USUARIO',
  userPlaceholder: 'Ingrese su usuario',
  passwordLabel: 'CONTRASEÑA',
  passwordPlaceholder: 'Ingrese su contraseña',
  submit: 'INGRESAR',
  forgotPassword: 'Olvidé mi contraseña',
  captchaRequired: '¡Se requiere captcha!',
};

export default login;
